var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMalicious(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 14V15.5M7.5 14V15.5M7.5 10.5V11.5M9.5 14V15.5M9.5 15.5H10.5C11.0523 15.5 11.5 15.0523 11.5 14.5V12.6337C11.5 12.1069 13.5 12.5 14 11.5C14.3496 10.8007 13.984 9.54581 13.7325 8.85424C13.6155 8.53253 13.5886 8.184 13.6559 7.84835C14.3255 4.5075 13.2034 0.5 7.5 0.5C1.79664 0.5 0.674508 4.5075 1.34412 7.84836C1.41139 8.184 1.3845 8.53253 1.26749 8.85424C1.01597 9.54581 0.650371 10.8007 1 11.5C1.50001 12.5 3.5 12.1069 3.5 12.6337V14.5C3.5 15.0523 3.94771 15.5 4.5 15.5H9.5Z",
    stroke: "#42526D",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8C6.5 8.82843 5.82843 9.5 5 9.5C4.17157 9.5 3.5 8.82843 3.5 8C3.5 7.17157 4.17157 6.5 5 6.5C5.82843 6.5 6.5 7.17157 6.5 8Z",
    stroke: "#42526D",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8C11.5 8.82843 10.8284 9.5 10 9.5C9.17157 9.5 8.5 8.82843 8.5 8C8.5 7.17157 9.17157 6.5 10 6.5C10.8284 6.5 11.5 7.17157 11.5 8Z",
    stroke: "#42526D",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalicious);
export default __webpack_public_path__ + "static/media/malicious.808b8a0fe119e9ad88760c957fc798a9.svg";
export { ForwardRef as ReactComponent };